module.exports = __webpack_public_path__ + "static/media/podejscia-do-cyberbezpieczenstwa-cover-pl.509b0da7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ebook/podejscia-do-cyberbezpieczenstwa-cover-pl.png
// module id = 556
// module chunks = 0